import { render, staticRenderFns } from "./imgsUploader.vue?vue&type=template&id=4de6d0ee&scoped=true"
import script from "./imgsUploader.vue?vue&type=script&lang=js"
export * from "./imgsUploader.vue?vue&type=script&lang=js"
import style0 from "./imgsUploader.vue?vue&type=style&index=0&id=4de6d0ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de6d0ee",
  null
  
)

export default component.exports